<div class="row" *ngIf="!!ricorsi && ricorsi.length > 0">
    <div class="col-12">
        <table class="table">
            <caption class="sr-only">Lista Ricorsi</caption>
            <thead>
                <tr>
                    <th scope="col" class="col-xs-3">Ruolo</th>
                    <th scope="col" class="col-xs-3">Data</th>
                    <th scope="col" class="col-xs-3">Materia</th>
                    <th scope="col" class="col-xs-3">Sezione</th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ricorso of currentRicorsi">
                    <td class="col-xs-3 cell">{{ replaceNull(ricorso.nrg) }}</td>
                    <td class="col-xs-4 cell pda-cons-anon-value">{{ !!ricorso.data
                    ? (ricorso.data | date: "dd/MM/yyyy HH:mm")
                    : '-' }}</td>
                    <td class="col-xs-3 cell">{{ replaceNull(ricorso.materia) }}</td>
                    <td class="col-xs-3 cell">{{ replaceNull(ricorso.sezione) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="card-pagination">
    <app-pagination [resetCurrentPage]="resetCurrentPage" [totalItems]="ricorsi != undefined ? ricorsi.length : 0"
        (refreshEvent)="onRefresh($event)">
    </app-pagination>
</div>

<div *ngIf="!!ricorsi && ricorsi.length === 0" class="row" aria-live="polite">
    <div class="col-sm-12 no-result">
        La consultazione non ha prodotto risultati
    </div>
</div>